// src/services/emailCampaignService.js
import { apiRequest } from '../api/client';
import { endpoints } from '../api/endpoints';

export function getCampaigns(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`${endpoints.EmailCampaigns}${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function getCampaign(id) {
    return apiRequest(endpoints.EmailCampaign(id), { method: 'GET' });
}

// Autosave-friendly: the backend upserts on `idempotencyKey`, so calling this repeatedly
// with the same key (and updated content) for one compose session updates the same draft.
export function saveDraft(campaign) {
    return apiRequest(endpoints.EmailCampaignDrafts, {
        method: 'POST',
        body: JSON.stringify(campaign),
    });
}

export function deleteCampaign(id) {
    return apiRequest(endpoints.EmailCampaign(id), { method: 'DELETE' });
}

// Sends (or schedules, via campaign.sendMode/scheduledAt) the full campaign payload in one
// idempotent call - there is no separate id-based send/schedule endpoint on the backend.
export function sendCampaign(campaign) {
    return apiRequest(endpoints.EmailCampaignSend, {
        method: 'POST',
        body: JSON.stringify(campaign),
    });
}

export function cancelCampaign(id) {
    return apiRequest(endpoints.EmailCampaignCancel(id), { method: 'POST' });
}

export function resendCampaign(id) {
    return apiRequest(endpoints.EmailCampaignResend(id), { method: 'POST' });
}

export function duplicateCampaign(id) {
    return apiRequest(endpoints.EmailCampaignDuplicate(id), { method: 'POST' });
}

export function sendTestEmail(payload) {
    return apiRequest(endpoints.EmailCampaignSendTest, {
        method: 'POST',
        body: JSON.stringify(payload),
    });
}

export function uploadCampaignAttachment(id, file) {
    const formData = new FormData();
    formData.append('file', file);
    const token = localStorage.getItem('accessToken');
    return apiRequest(endpoints.EmailCampaignAttachments(id), {
        method: 'POST',
        headers: token ? { Authorization: `Bearer ${token}` } : {},
        body: formData,
    });
}

export function exportCampaignsCsv(params = {}) {
    const qs = new URLSearchParams(params).toString();
    return apiRequest(`${endpoints.EmailCampaignsExport}${qs ? `?${qs}` : ''}`, { method: 'GET' });
}

export function getAnalyticsSummary() {
    return apiRequest(endpoints.EmailAnalyticsSummary, { method: 'GET' });
}
